import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ChromelessButton} from '../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {SynopsisItem} from './synopsisHelpers';

interface SynopsisCollapsedGroupProps {
  className?: string;
  items: ReadonlyArray<SynopsisItem>;
  onExpand: () => void;
}

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledCollapsedButton = styled(ChromelessButton)`
  display: flex;
  flex-direction: row;
  color: ${(p) => p.theme.text};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.semibold};
  gap: 5px;
  border-radius: 14px;
  padding: 4px 8px;
  align-items: center;
  margin-left: -8px;
  width: fit-content;

  &:hover {
    background-color: ${(p) => p.theme.alphas.black20};
  }
`;

export const SynopsisCollapsedGroup: FC<SynopsisCollapsedGroupProps> = ({className, items, onExpand}) => (
  <StyledWrap className={className}>
    <StyledCollapsedButton onClick={onExpand}>
      <Plural id="synopsis-collapsed-summaries" one="1 hidden" other="# hidden" value={items.length} />
    </StyledCollapsedButton>
  </StyledWrap>
);
